// src/features/MedicalServices/page/Category

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import { Tag } from 'antd'; //Space, Tag,
import type { ColumnsType } from 'antd/es/table';

import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { ServiceItemType } from '../../types/medicalServicesTypes';



const ServiceItemPage = () => {
    

    // Define columns for the ServiceItem table
    const ServiceItemColumns: ColumnsType<ServiceItemType> = [
        { title: "Name", dataIndex: "name", key: "name"},
        //{ title: "NameAr", dataIndex: "nameAr", key: "nameAr" },
        { title: "Category", dataIndex: "category", key: "category" },
        //{ title: "Description", dataIndex: "description", key: "description" },
        //{ title: "DescriptionAr", dataIndex: "descriptionAr", key: "descriptionAr" },
        {
            title: "Active",
            dataIndex: "isActive",
            key: "isActive",
            render: (isActive: boolean) => (
                <Tag color={isActive ? "green" : "red"}>{isActive ? "Yes" : "No"}</Tag>
            ),
        },

    ];

    return (
        <div>
            <DynamicTable<ServiceItemType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.MEDICALSERVICES.SEARCH_SERVICECATEGORYITEM} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.MEDICALSERVICES.SERVICECATEGORYITEMS} // Unique query key for menus
                columns={ServiceItemColumns}
                tableTitle={"Sub Services"}
                showActions={true} // Set to true if you want Edit/Delete actions
                deleteBaseUrl={API_ENDPOINTS.MEDICALSERVICES.DELETE_SERVICECATEGORYITEM}
                deletePayloadField= "name"
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    {
                        field: 'serviceCategoryId',
                        type: 'select',
                        placeholder: "Select main service",
                        showSearch: true,
                        dynamicOptions: {
                            url: "/Lookup/GetDropdownData",
                            method: "POST",
                            body: { "dropdowns": ["servicecategory"] },
                            transformData: (apiResponse: unknown) => {
                                const response = apiResponse as { servicecategory: { Name: string; Id: number }[] };
                                return response.servicecategory.map((item) => ({ label: item.Name, value: item.Id }))
                            }
                        },
                    },
                    { field: "name", placeholder: "Search by sub service" },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.MEDICALSERVICES.EXPORT_SERVICECATEGORYITEM,
                            fileName: "ServiceCategoryItems",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                                { header: "Name", key: "name" },
                                { header: "Arabic Name", key: "nameAr" },
                                { header: "Category", key: "category" },
                                //{ header: "Description", key: "description" },
                                //{ header: "DescriptionAr", key: "descriptionAr" },
                                { header: "Active", key: "isActive", transform: (val: boolean) => val === true ? "Yes" : "No" },
                            ]
                        }
                    }
                ]}
            />
        </div>
    );
};

export default ServiceItemPage;